import { render, staticRenderFns } from "./OrderFulfillment.vue?vue&type=template&id=03ab98e6"
import script from "./OrderFulfillment.vue?vue&type=script&lang=js"
export * from "./OrderFulfillment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports